import { withStyles } from '@material-ui/core';
import FullScreenSpinner from './FullScreenSpinner';
import styles from './styles';

export default withStyles(styles)(FullScreenSpinner);
